import React from "react";

import { CopyCourseContainer } from "../components/courses/copy-course-container";

const CopyCourse: React.FC = () => {
  return <CopyCourseContainer />;
};

export default CopyCourse;
